import { Context, createContext, ReactNode } from 'react';
import { RouterType } from '.';

export type RouteContextType = {
  routes?: RouterType[];
  pageName?: string;
  breadcrumbNameMap?: Record<string, string>;
  mobileRightHeader?: ReactNode;
  setMobileRightHeader?: (rn: ReactNode) => void;
  setPageName?: (name: string) => void;
  isMobile?: boolean;
  menuCollapsed?: boolean;
};
const RouteContext: Context<RouteContextType> = createContext({});

export default RouteContext;
